import { usePermission } from "../hooks/usePermission";
import { CanAccessProps } from "../type/type";

const CanAccess = ({
  module,
  permission,
  children,
  fallback = null,
}: CanAccessProps): React.ReactNode => {
  const { can } = usePermission();

  if (!can(module, permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default CanAccess;
